// Redux 
import GeckoStore from '../../../../services/GeckoStore';
import {
    updateStream
} from '../../../../redux/actions';

export const STREAM_STATUS_LOCKED       = 'locked';
export const STREAM_STATUS_CONNECTED    = 'connected';
export const STREAM_STATUS_ACTIVE       = 'active';
export const STREAM_STATUS_DISCONNECTED = 'disconnected';
export const STREAM_STATUS_IDLE         = 'idle';

const updateStoreFn = (status, view_url = null) => {
	GeckoStore.redux.dispatch(updateStream({status, view_url}));
};

export const StreamService = {

	isConnected    : (status) => status === STREAM_STATUS_CONNECTED,
	isActive       : (status) => status === STREAM_STATUS_ACTIVE,
	isDisconnected : (status) => status === STREAM_STATUS_DISCONNECTED,
	isIdle         : (status) => status === STREAM_STATUS_IDLE,

	load       : (viewUrl) => viewUrl ? StreamService.active(viewUrl) : StreamService.idle(),
	
	connect    : (viewUrl) => updateStoreFn(STREAM_STATUS_CONNECTED),
	active     : (viewUrl) => updateStoreFn(STREAM_STATUS_ACTIVE, viewUrl),
	disconnect : () => updateStoreFn(STREAM_STATUS_DISCONNECTED),
	idle       : () => updateStoreFn(STREAM_STATUS_IDLE),

};

export default StreamService;